<template>
  <div style="margin-left: 4px; margin-right: 4px">
    <div
      class="p-grid"
      style="display: inline; margin: auto"
      v-for="(an_item, k) in code"
      :key="k"
    >
      <barcode
        v-model="an_item.code"
        :options="options"
        class="p-col-4"
        style="margin-top: 6px; margin-bottom: 12px"
      ></barcode>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      code: []
    }
  },
  computed: {
    options() {
      return {
        height: 100,
        textAlign: 'center',
        textPosition: 'top'
      }
    }
  },
  mounted() {
    this.getVouchers()
    setTimeout(function () {
      window.print()
    }, 500)
    setTimeout(function () {
      window.close()
    }, 500)
  },
  methods: {
    async getVouchers() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/vouchers?status=available`
        )

        if (response.status === 200) {
          this.code = response.data.data.vouchers
        } else {
          console.error('Gagal mendapatkan data voucher')
        }
      } catch (error) {
        console.error('Terjadi kesalahan saat mengambil data voucher:', error)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
